import { render, staticRenderFns } from "./close-branch-vault.vue?vue&type=template&id=c199286a&"
import script from "./close-branch-vault.vue?vue&type=script&lang=js&"
export * from "./close-branch-vault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports